import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

export async function downloadBlob(url, filename) {
  const r = await axios.get(url, { responseType: 'blob' });
  const href = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement('a');
  a.href = href;
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(href);
}

export async function shareAchievement(registrationId, challenge) {
  try {
    const r = await axios.get(`${API}/registrations/${registrationId}/share-image/${challenge.id}`, { responseType: 'blob' });
    const file = new File([r.data], `logro_${challenge.name}.png`, { type: 'image/png' });
    const text = `¡Reto ${challenge.name} completado con Strategos Overland!`;
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: text, text });
      return;
    }
    const href = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = href; a.download = file.name; document.body.appendChild(a); a.click(); a.remove();
    window.URL.revokeObjectURL(href);
    toast.success('Imagen descargada: compártela en WhatsApp o Instagram');
  } catch (e) {
    if (e?.name === 'AbortError') return;
    let detail = 'No se pudo generar la imagen';
    try { detail = JSON.parse(await e.response?.data?.text())?.detail || detail; } catch { /* ignore */ }
    toast.error(detail);
  }
}

export async function downloadDiploma(registrationId, challenge) {
  try {
    await downloadBlob(`${API}/registrations/${registrationId}/diploma/${challenge.id}`, `diploma_${challenge.name}.pdf`);
    toast.success(`Diploma ${challenge.name} descargado`);
  } catch (e) {
    let detail = 'No se pudo generar el diploma';
    try { detail = JSON.parse(await e.response?.data?.text())?.detail || detail; } catch { /* ignore */ }
    toast.error(detail);
  }
}
